import Label from '@/components/ui/forms/Label';
import StatusBadge, { type Status } from '@/components/ui/forms/StatusBadge';

interface Props {
  children: React.ReactNode;
  valid?: boolean;
  required?: boolean;
}

const getStatus = (valid: boolean, required: boolean): Status =>
  valid ? 'ok' : required ? 'required' : 'optional';

const LabelWithStatus: React.FC<Props> = ({
  children,
  valid = false,
  required = false,
}) => (
  <Label prefix={<StatusBadge status={getStatus(valid, required)} />}>
    {children}
  </Label>
);

export default LabelWithStatus;
